import { VehicleReportsIds } from '../models/interfaces/vehicle-by-reports.model';
export class ReportsState {
  vehiclesReportsIds: VehicleReportsIds[] = [];
  config: any;
  generatedReport: any;
  loadingReport = false;
}
